import React from 'react';
import { Route, Navigate } from 'react-router-dom';

const ProtectedFroute = ({ element }) => {
  const isTokenExists = localStorage.getItem('mtoken'); 

  return isTokenExists ? element : <Navigate to="/mentor-login" />;
};

export default ProtectedFroute;
